import { Form, Space, Typography } from "antd";
import { Toggle } from "@libertify/ui";
import { PlaybookDurationSlider } from "./PlaybookDurationSlider";
import { useTranslate } from "@refinedev/core";

export const DurationFormItem = ({
  enabled,
  formValue,
  onToggleChange,
  onDurationChange,
}: {
  enabled: boolean;
  formValue: number;
  onToggleChange: (value: boolean) => void;
  onDurationChange: (value: number) => void;
}) => {
  const t = useTranslate();
  // The toggle represents "auto" mode: ON when no duration is set, so the
  // duration is chosen automatically from the document. `enabled` carries the
  // data meaning (a concrete duration is set), so auto is its inverse.
  const isAuto = !enabled;
  return (
    <Form.Item label={t("pages.playbooks.sections.basic.defaultDuration")}>
      <Space direction="vertical" size={12} style={{ width: "100%" }}>
        <Space size={8} style={{ height: 40 }}>
          <Toggle
            size="l"
            checked={isAuto}
            onChange={(checked) => onToggleChange(!checked)}
          />
          <Typography.Text strong>
            {t("pages.playbooks.sections.basic.durationAuto")}
          </Typography.Text>
        </Space>
        {!isAuto && (
          <PlaybookDurationSlider
            value={formValue}
            onChange={onDurationChange}
          />
        )}
      </Space>
    </Form.Item>
  );
};
